export default "__VITE_ASSET__CerJscUt__"